import type { ChangeEvent } from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
import Text from "@/components/forms/text";
import RadioGroup from "@/components/forms/radio-group";
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Plus, Trash2 } from 'lucide-react';
import AprilPicto from '@/components/shared/april-picto';
import { PictoSoutien } from '@/assets/icons-april-fr/pictos';

const Blesses = () => {
    const { control, watch, setValue } = useFormContext();
    const { fields, append, remove } = useFieldArray({ control, name: 'victimes' });

    const blesse = watch('blesse');

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setValue(name, value);
    };

    return (
        <Card className="mt-6">
            <CardHeader className="pb-6 border-b">
                <CardTitle className="text-lg flex items-center gap-2">
                    <AprilPicto icon={PictoSoutien} size="md" />
                    Blessé(e)(s)
                </CardTitle>
            </CardHeader>
            <CardContent className="pt-6 space-y-8">
                <RadioGroup
                    label="Y-a-t-il d'autre(s) blessé(s) ?"
                    name="blesse"
                    setValue={setValue}
                    options={[{ value: "T", label: "Oui" }, { value: "F", label: "Non" }]}
                    value={blesse}
                />

                {blesse === 'T' && (
                    <div className="space-y-6">
                        {fields.map((field, i) => (
                            <div key={field.id} className="space-y-5 p-6 bg-muted/30 rounded-lg">
                                <div className="flex items-center justify-between">
                                    <p className="text-sm font-semibold">Victime n°{i + 1}</p>
                                    {fields.length === (i + 1) && (
                                        <Button variant="outline" size="sm" onClick={() => remove(i)} className="!border-destructive !text-destructive hover:!border-destructive/70 hover:!text-destructive/70 cursor-pointer">
                                            <Trash2 className="w-4 h-4" />
                                        </Button>
                                    )}
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                                    <Text name={`victimes.${i}.nom`} onChange={handleChange} label="Nom" value={watch(`victimes.${i}.nom`)} normalize={v => v.toUpperCase()} />
                                    <Text name={`victimes.${i}.prenom`} onChange={handleChange} label="Prénom" value={watch(`victimes.${i}.prenom`)} normalize={v => v.toUpperCase()} />
                                </div>
                                <RadioGroup
                                    label="Situation"
                                    name={`victimes.${i}.type_victime`}
                                    setValue={setValue}
                                    options={[{ value: "P", label: "Passager" }, { value: "N", label: "Passager adverse" }, { value: "W", label: "Piéton" }, { value: "V", label: "Cycliste" }]}
                                    value={watch(`victimes.${i}.type_victime`)}
                                    className="!max-w-lg"
                                />
                            </div>
                        ))}
                        <Button variant="outline" onClick={() => append({})} className="cursor-pointer">
                            <Plus className="w-4 h-4" />
                            Ajouter une victime
                        </Button>
                    </div>
                )}
            </CardContent>
        </Card>
    );
};

export default Blesses;
